import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLeanportSwitches } from '../hooks/useLeanportSwitches';

/** Panel shown to members on a page only administrators may use. */
export const AccessRestricted: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="hub-card p-10 text-center" role="alert">
      <Lock size={20} className="mx-auto mb-3" style={{ color: 'var(--hub-ink-3)' }} />
      <div className="hub-card-title">{t('common.accessRestricted')}</div>
      <p className="hub-sub" style={{ marginTop: 4 }}>
        {t('common.accessRestrictedHint')}
      </p>
    </div>
  );
};

interface AdminRouteProps {
  /**
   * Leanport: restrict only while MCPHUB_ADMIN_ONLY_CONFIG is on (pages that
   * merely change configuration); otherwise the routes are always admin-only.
   */
  onlyWhenAdminOnlyConfig?: boolean;
}

/** Route guard that renders its child routes for administrators only. */
const AdminRoute: React.FC<AdminRouteProps> = ({ onlyWhenAdminOnlyConfig = false }) => {
  const { auth } = useAuth();
  const { adminOnlyConfig } = useLeanportSwitches();
  const restricted = onlyWhenAdminOnlyConfig ? adminOnlyConfig : true;

  if (restricted && !auth.user?.isAdmin) {
    return <AccessRestricted />;
  }
  return <Outlet />;
};

export default AdminRoute;
